<template>
  <div :class="{ menuHide: $root.menuHide }">
    <el-row>
      <el-col :span="24">
        <div class="page-footer">
            <span class="code-item">{{ data.copyright }}</span>
            <span class="code-item">ICP证：{{ data.icp }}</span>
            <a class="code-item" :href="'mailto:' + data.email" style="text-decoration: underline;">客服邮箱：{{ data.email }}</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data:{
        copyright:'Copyright ©2021 卓晟互联（北京）信息科技有限公司',
        icp: '京ICP备18044042号-1 ',
        email: 'support@joshvm.com'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/css/style.scss';
.page-footer {
  position: fixed;
  left: 210px;
  bottom: 0;
  padding: 10px;
  width: calc(100% - 200px);
  font-size: 14px;
  color: #9A9A9A;
  background-color: #ffffff;
  border-top: 1px solid $color-bolder;
  z-index: 9;
  .code-item {
    margin-right:20px;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/Footer.vue